// extracted by mini-css-extract-plugin
export default {"text":"FindingOpponent2_text__Cofrh","text_vs":"FindingOpponent2_text_vs__++Zlj"};